<script lang="ts">
	//Services
	import { format } from '../../../../services/i18n';
	import { localReq, postReq } from '../../../../services/http';
	//Stores
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	//Design system
	import { Button, Input, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);

	let settings = readDeviceSettings(id);
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore ?? settings;
	let value = settings.min_brightness;
	let cache = value;
	const min = 0;
	const max = 50;
	let localIp = get_local_ip(id);
	let loading = false;

	const setMinBrightness = async () => {
		if (cache !== value) {
			let res;
			loading = true;
			if (localIp) {
				res = await localReq(device, `${localIp}/settings/`, 'post', {
					min_brightness: value,
				});
			} else {
				res = await postReq(`/device/${device.category}/settings/min_brightness`, {
					min_brightness: value,
					channel: device.channel,
					id: id,
				});
			}

			if (res.isok) {
				settings.min_brightness = value;
				devices_settings.update_devices_settings(id, settings);
				toast.open({
					type: 'success',
					title: $format('min_brightness_scc_toast', {
						values: { value },
						default: `Min brightness value was changed to ${value}%.`,
					}),
				});
				cache = value;
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
				value = cache;
			}
			loading = false;
		}
	};
</script>

<Input
	class="mb-s"
	size="m"
	bind:value
	placeholder_text={value}
	type={'number'}
	{min}
	{max}
	info={$format('min_brightness_dimmer_description', {
		values: { min, max },
	})}
	on:enter={setMinBrightness}
	id="input-roj20sx"
	aria-label={$format('min_brightness_dimmer_description', {
		values: { min, max },
	})}
/>
<Button class="mt-s" {loading} size="m" width="full" on:click={setMinBrightness}
	>{$format('button_save')}</Button
>
